import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/redeem')({
  beforeLoad: async ({ search, location }) => {
    search.redeem = true
    throw redirect({
      to: '/',
      search,
      state: {
        ...location.state,
        from: location.state.from ? location.state.from : 'deeplink',
      },
    })
  },
})
